import { render } from "./ViewsOrderSubmitted.vue?vue&type=template&id=1cd50280"
import script from "./ViewsOrderSubmitted.vue?vue&type=script&lang=js"
export * from "./ViewsOrderSubmitted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__